import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { useTranslation } from "react-i18next";
import { Heading } from "src/components/base/heading";
import { Text } from "src/components/base/text";

/**
 * The properties for {@link ErrorTailscaleAuthentication}
 */
export type ErrorTailscaleAuthenticationProps = {};

/**
 * The error page for tailscale user authentication
 */
export default function ErrorTailscaleAuthentication(props: ErrorTailscaleAuthenticationProps) {
    const [t] = useTranslation("static");

    return (
        <div className={"flex flex-col items-center justify-center gap-4"}>
            <Heading>{t("heading.tailscale-invalid-csrf")}</Heading>
            <Text>{t("description.tailscale-invalid-csrf")}</Text>
        </div>
    );
}

export const Route = createFileRoute("/_static/s/tailscale-login/invalid-csrf")({
    component: ErrorTailscaleAuthentication,
});
